module.exports = __webpack_public_path__ + "static/media/clemazon_g.afe63bef.png";